export function extractHTMLText(data: string) {
  const div = document.createElement("div");
  div.innerHTML = data;
  return div.textContent || div.innerText || "";
}
